export const CALL_TYPE = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
  VOICE: 'voice',
  VIDEO: 'video',
  COBROWSE: 'cobrowse',
  SCREENSHARE: 'screenshare',
};

export default {
  CALL_TYPE,
};